import { useEffect, useState } from "react"
import { Form, Col, Modal, ModalBody, Button, Row } from "react-bootstrap"
import { AppPageWrapper } from "../../NavMenu/AppPageWrapper"
import ActionButton from "../../ActionButton"
import FromToDates from "../FromToDates"
import { useHistory } from "react-router"
import { Home } from "../../../config/Routes"
import DualListBox from "../../Administration/DualListBox"
import { useSelector } from "react-redux"
import { isPortalAdmin } from "../../../authentication/isAdminRole"
import { AppState } from "../../../AppState"
import { GetSelectedAssignedClinic } from "../../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import { FaFileCsv, FaFilePdf, FaSync, FaSyncAlt } from "react-icons/fa"
import FormatDate from "../../../formatters/FormatDate"
import FormatTimestampFileName from "../../../formatters/FormatTimestampFileName"
import exportCsv from "../../../utils/exportCsv"
import handleAPIError from "../../../utils/handleAPIError"
import { RegulatoryModeDataLoader } from "../../../api/Reports/RegulatoryModeDataLoader"
import RegulatoryMode from "../../../api/LabService/LabServiceModel/RegulatoryMode"
import {MissingRegModeOrEmployeeCategoryReportGetCsv} from "../../../api/Reports/MissingRegModeOrEmployeeCategoryReport"
import { PoolsGetObservable } from "../../../api/Randoms/PoolGeneralInfoGet"
import { Pool } from "../../../api/Randoms/RandomsModel/PoolData"
import { PoolDataLoader } from "../../../api/Reports/PoolDataLoader"
import { MissingRegModeOrEmployeeCategoryReportParams} from "../../../api/Reports/MissingRegModeOrEmployeeCategoryReport"



const MissingRegModeOrEmployeeCategoryReport = () => {
  const portalAdmin = useSelector((state: AppState) => isPortalAdmin(state))
  const clinic = useSelector((state: AppState) => GetSelectedAssignedClinic(state))
  const history = useHistory();

  const [generatingCsv, setGeneratingCsv] = useState(false)
  const [pools, setPools] = useState<PoolDataLoader>({ data: [], loading: false })
  const [selectedPools, setSelectedPools] = useState<Pool[]>([])
  const [from, setFrom] = useState<Date>()
  const [to, setTo] = useState<Date>()

  
  useEffect(() => {
    setPools(prev => ({ data: prev.data, loading: true }))
    const sub = PoolsGetObservable().subscribe(
      res => setPools({ data: res, loading: false }),
      error => handleAPIError(error, () => setPools(prev => ({ ...prev, loading: false })))
    )
    return () => sub.unsubscribe()
  }, []);
  
  
  useEffect(() => {
    setFrom(from)
    setTo(to)
  })

  const isParamsValid = () => (
    !!from && 
    !!to
  )

  const getReportParams = (): MissingRegModeOrEmployeeCategoryReportParams => ({
    PoolIds: selectedPools.length > 0 ? selectedPools?.map(a => a.PoolID) : [],
    DateFrom: FormatDate(from),
    DateTo: FormatDate(to)
  })

  const handleCancelClick = () => history.push(Home)
  const handleClearClick = () => {
    setSelectedPools(pools.data)
    setFrom(undefined)
    setTo(undefined)
  }

    const handleGenerateCsvClick = () => {
    setGeneratingCsv(true)
    MissingRegModeOrEmployeeCategoryReportGetCsv(getReportParams()).subscribe(
      (results: string) => {
        setGeneratingCsv(false)
        exportCsv(results, FormatTimestampFileName("MissingRegModeOrEmployeeCategoryReport", "csv", new Date()))
      },
      error => handleAPIError(error, () => setGeneratingCsv(false))
    )
  }

  return (
    <AppPageWrapper parentClassName={"align-items-center"} showNav>
      <Modal.Dialog size="lg">
        <Modal.Header>
          <Modal.Title className="text-uppercase">Missing Reg Mode and/or Employee Category</Modal.Title>
        </Modal.Header>
        <ModalBody>
          <Form>
            <Form.Row className="form-group">
              <Col lg={3}>Date Collected</Col>
              <Col lg={8}>
                <FromToDates from={from} to={to} onChangeFrom={setFrom} onChangeTo={setTo} />
              </Col>
            </Form.Row>
            <Form.Row>
              <Col>
                <Form.Label className="required">Regulatory Modes</Form.Label>
                <DualListBox
                  disabled={pools.loading}
                  options={pools.data}
                  selected={selectedPools}
                  idKey="PoolID"
                  labelKey="PoolName"
                  availableTitle="Available"
                  selectedTitle="Selected"
                  onChange={setSelectedPools}
                />
              </Col>
            </Form.Row>
          </Form>
        </ModalBody>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelClick}>Cancel</Button>
          <Button variant="secondary" className="mr-auto" onClick={handleClearClick}>Clear Filter&nbsp;<FaSync /></Button>
          <ActionButton variant="primary" disabled={pools.loading || !isParamsValid()} onClick={handleGenerateCsvClick} spin={generatingCsv} disableOnSpin>Export CSV&nbsp;<FaFileCsv /></ActionButton>
        </Modal.Footer>
      </Modal.Dialog>
    </AppPageWrapper >)
}
export default MissingRegModeOrEmployeeCategoryReport
